import { render } from "./ReturnListePage.vue?vue&type=template&id=b87a9ea2&ts=true"
import script from "./ReturnListePage.vue?vue&type=script&lang=ts"
export * from "./ReturnListePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__